{
  "name": "attack-navigator",
  "description": "Web app that provides basic navigation and annotation of ATT&CK matrices",
  "repository": {
    "type": "git",
    "url": "https://github.com/mitre-attack/attack-navigator.git"
  },
  "version": "5.3.2",
  "license": "Apache-2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 0.0.0.0",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "prettier": "npx prettier src --check",
    "prettier:fix": "npm run prettier -- --write"
  },
  "dependencies": {
    "@angular/animations": "^19.2.20",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.20",
    "@angular/compiler": "^19.2.20",
    "@angular/core": "^19.2.20",
    "@angular/forms": "^19.2.20",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.20",
    "@angular/platform-browser-dynamic": "^19.2.20",
    "@angular/router": "^19.2.20",
    "@babel/runtime": "^7.29.2",
    "@fontsource/roboto": "^5.2.8",
    "@fontsource/roboto-mono": "^5.2.8",
    "@types/file-saver": "^2.0.1",
    "classlist.js": "^1.1.20150312",
    "core-js": "^3.48.0",
    "d3": "^7.8.5",
    "d3-svg-legend": "^2.25.6",
    "detect-browser": "^5.3.0",
    "file-saver": "^2.0.5",
    "load-json-file": "^7.0.1",
    "mathjs": "^15.2.0",
    "ngx-color-picker": "^19.0.0",
    "ngx-drag-drop": "^19.0.0",
    "ngx-markdown": "^19.1.1",
    "rxjs": "^7.8.1",
    "rxjs-compat": "^6.6.7",
    "tinycolor2": "^1.6.0",
    "tinygradient": "^2.0.1",
    "tslib": "^2.5.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^19.0.1",
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular/cli": "^19.2.23",
    "@angular/compiler-cli": "^19.2.20",
    "@angular/language-service": "^19.2.20",
    "@types/jasmine": "^6.0.0",
    "@types/jasminewd2": "^2.0.8",
    "@types/node": "^22.19.17",
    "codelyzer": "^6.0.0",
    "exceljs": "^4.3.0",
    "jasmine-core": "^6.2.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "^3.2.0",
    "karma-cli": "~2.0.0",
    "karma-coverage": "^2.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "marked": "^15.0.12",
    "prettier": "^3.8.1",
    "ts-node": "^10.9.1",
    "tslint": "~6.1.0",
    "typescript": "^5.8.3"
  },
  "optionalDependencies": {
    "fsevents": "^2.3.2"
  }
}
